import { FC } from 'react';

const LoadingSpinnerComponent: FC = () => {
    return (
        <div className="loading__spinner">
            <svg
                aria-hidden="true"
                focusable="false"
                className="spinner"
                viewBox="0 0 66 66"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle className="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
        </div>
    );
};

export default LoadingSpinnerComponent;
